import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { HourglassIcon } from 'lucide-react';

/**
 * Shown if a guest lands back on the booking page from Paystack (?reference= / ?trxref=).
 * Deliberately makes NO claim that payment succeeded — confirmation comes only from the
 * backend's server-side verification and its confirmation email.
 */
export function PaymentReturnNotice() {
  const [params] = useSearchParams();
  const reference = params.get('reference') ?? params.get('trxref');
  if (!reference) return null;
  return <div className="mb-10 flex items-start gap-3 rounded-sm bg-gold-100 p-5 text-[14px] leading-relaxed text-forest-700" role="status" data-id="element-148" data-mp="3v3ckpm2wg714">
      <HourglassIcon size={18} className="mt-0.5 shrink-0 text-gold-600" aria-hidden="true" data-id="element-149" data-mp="3m4902do33jki" />
      <div data-id="element-150" data-mp="1oehenst5oo7m">
        <p className="font-normal" data-id="element-151" data-mp="1oe7mbykn24yr">Thanks — we’re verifying your payment.</p>
        <p className="mt-1 text-[13px] text-muted" data-id="element-152" data-mp="1oc50zrufl00d">
          Payment reference <span className="break-all text-ink" data-id="element-153" data-mp="1kddyf5774q5v">{reference}</span>. Your booking is confirmed only once our
          booking system has verified the payment with Paystack, and you’ll receive a confirmation email. Please don’t pay again.
        </p>
      </div>
    </div>;
}